import { StyleSheet } from 'react-native'

const useStyles = (theme, isTablet) => StyleSheet.create({
  container: {
    flex: 1,
    backgroundColor: theme.WHITE
  },
  header: {
    paddingHorizontal: 20
  },
  texts: {
    marginTop: isTablet ? 40 : 0,
    marginBottom: 10
  },
  content: {
    flex: 1,
    flexDirection: 'row'
  },
  list: {
    flex: 1,
    marginHorizontal: isTablet ? 40 : 10
  },
  mapContainer: {
    flex: 1,
    margin: 40
  },
  map: {
    flex: 1,
    marginTop: 80
  },
  addButton: {
    position: 'absolute',
    right: 20,
    bottom: 20
  },
  addButtonLargeContainer: {
    alignItems: 'flex-end',
    marginVertical: 10
  },
  addButtonLarge: {
    width: 140,
    height: 25
  }
})

export default useStyles
